import template   from './error.html'
import controller from './error.controller'
import './error.styl'

let component = {
  restrict: 'E',
  bindings: {
    error: '<',
    title: '@',
    description: '@'
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/common/error/error.component.js